import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaUserTie, FaUsers, FaBriefcase, FaFilter, FaHandshake, FaRobot, FaChartLine, FaBuilding, FaClipboardList, FaTasks, FaUserCheck, FaUserClock } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const TalentAquisition = () => {
  return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>

      <Card
        sx={{
          background: "rgba(0, 0, 0, 0.9)",
          color: "white",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(15px)",
          textAlign: "center",
        }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Unlocking Talent, Empowering Growth
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Optimize your hiring process with our expert Talent Acquisition solutions, connecting you with top-tier professionals and future-proofing your workforce.
          </Typography>
        </CardContent>
      </Card>

      {/* Talent Acquisition Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {talentServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      <OurNumbers />
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Icon Box
const logoBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "80px",
  height: "80px",
  borderRadius: "10px",
  backgroundColor: "rgba(211, 154, 158, 0.08)",
  marginBottom: "15px",
  boxShadow: "0 0 5px rgba(211, 154, 158, 0.5), 0 0 10px rgba(211, 154, 158, 0.5), 0 0 20px rgba(211, 154, 158, 0.5)",
  fontSize: "2rem",
};

// Talent Acquisition Services List
const talentServices = [
  {
    title: "Executive Search & Headhunting",
    description: "Find and attract top C-suite executives and industry leaders for your organization.",
    icon: <FaUserTie />,
  },
  {
    title: "Bulk & Volume Hiring",
    description: "Scale your workforce efficiently with streamlined bulk hiring solutions.",
    icon: <FaUsers />,
  },
  {
    title: "Recruitment Process Outsourcing (RPO)",
    description: "Outsource your end-to-end hiring process to optimize efficiency and cost.",
    icon: <FaBriefcase />,
  },
  {
    title: "AI-Driven Talent Matching",
    description: "Leverage AI and machine learning to find the best candidates for the role.",
    icon: <FaRobot />,
  },
  {
    title: "Employer Branding & EVP Strategy",
    description: "Enhance your employer reputation to attract and retain top talent.",
    icon: <FaBuilding />,
  },
  {
    title: "Skill-Based & Competency Hiring",
    description: "Shift from resume-based to skills-driven hiring to ensure the right talent fit.",
    icon: <FaClipboardList />,
  },
  {
    title: "Workforce Planning & Talent Analytics",
    description: "Use data-driven insights to optimize workforce planning and future hiring trends.",
    icon: <FaChartLine />,
  },
  {
    title: "Freelance & Gig Workforce Solutions",
    description: "Access flexible talent with specialized gig workforce hiring solutions.",
    icon: <FaUserClock />,
  },
  {
    title: "Candidate Screening & Background Checks",
    description: "Ensure trust and security with comprehensive background verification.",
    icon: <FaFilter />,
  },
];

export default TalentAquisition;
